import { SecureStorage } from "@/secure-storage";

export const secureStorage = new SecureStorage({
  secretKey: "y5IgoNq+vRu3BBhud9WnfpCGbV1yvKou9AY9hYYJJyc="
});
